
/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Components/EndpointChecksComponent" />
import * as React from "react";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { ChecksOverview } from "Checks/ChecksOverview/ChecksOverview";

export interface IProps {
    resourceId: string;
    resourceName: string;
    hasManagePermission: boolean;
}

export interface IState {
    dataInitialized: boolean;
}

export class EndpointChecksComponent extends VssComponent<IProps, IState> {

    constructor(props: IProps, context: IVssComponentContext) {
        super(props, context);
        this._pageContext = context.pageContext;
        this.state = { dataInitialized: false };
    }

    public componentDidMount() {
        let contributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
        //Making aysnc call directly from component since this is a temp change. Ideally we should not do this and all calls should happen via actionCreator
        contributionService.getDataAsync("ms.vss-pipelinechecks.checks-data-provider", {"resourceId": this.props.resourceId}, true).then((data) => {
            if (this._isMounted) {
                this.setState({ dataInitialized: true});
            }
        }, (error) => {
        });
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        if (this.state.dataInitialized) {
            return (
                <div className="pipeline-checks page-content page-content-top flex flex-grow flex-column">
                    <ChecksOverview
                    resourceType={this._endpointResourceType}
                    resourceId={this.props.resourceId}
                    resourceName={this.props.resourceName}
                    hasManagePermission={this.props.hasManagePermission}
                    dataProviderRequestParameters={{"resourceId": this.props.resourceId}}/>
                 </div>
            );
        }
        return null;
    }

    private _pageContext: IVssPageContext;
    private _endpointResourceType: string = "endpoint";
    private _isMounted: boolean = true;
}
